import { render, staticRenderFns } from "./VehicleInfo.vue?vue&type=template&id=6dc1018d&scoped=true"
import script from "./VehicleInfo.vue?vue&type=script&lang=js"
export * from "./VehicleInfo.vue?vue&type=script&lang=js"
import style0 from "./VehicleInfo.vue?vue&type=style&index=0&id=6dc1018d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc1018d",
  null
  
)

export default component.exports